module.exports = __webpack_public_path__ + "img/renan.a723c111.jpg";